var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"px-7"},[_c('div',{staticClass:"list-header py-3 mt-1"}),_c('v-row',{staticClass:"mb-4"},[_c('v-col',{attrs:{"md":"12"}},[_c('div',{staticClass:"form-stepper-header"},[_c('div',{staticClass:"form-stepper-header-item",class:{
          active: _vm.form === 1,
        }},[_c('span',{staticClass:"value"},[_vm._v("1")]),_c('span',{staticClass:"label"},[_vm._v("Main Data")])]),_c('div',{staticClass:"form-stepper-header-splitter"},[_c('span')]),_c('div',{staticClass:"form-stepper-header-item",class:{
          active: _vm.form === 2,
        }},[_c('span',{staticClass:"value"},[_vm._v("2")]),_c('span',{staticClass:"label"},[_vm._v("Peserta")])]),_c('div',{staticClass:"form-stepper-header-splitter"},[_c('span')]),_c('div',{staticClass:"form-stepper-header-item",class:{
          active: _vm.form === 3,
        }},[_c('span',{staticClass:"value"},[_vm._v("3")]),_c('span',{staticClass:"label"},[_vm._v("Foto Absensi & Dokumentasi")])])])])],1),_c('ValidationObserver',{directives:[{name:"show",rawName:"v-show",value:(_vm.form === 1),expression:"form === 1"}],ref:"firstForm",staticClass:"geko-form-wrapper",scopedSlots:_vm._u([{key:"default",fn:function({ handleSubmit }){return [_c('form',{attrs:{"autocomplete":"off"},on:{"submit":function($event){$event.preventDefault();return handleSubmit(_vm.onSubmit)}}},[_c('v-row',[_c('v-col',[_c('geko-input',{attrs:{"item":{
            label: 'Tahun Program',
            validation: ['required'],
            col_size: 6,
            type: 'select',
            setter: 'program_year',
            option: {
              default_options: _vm.$_config.programYear.options.map(
                (x) => {
                  return {
                    code: x,
                    label: x
                  }
                }
              ),
              list_pointer: {
                code: 'code',
                label: 'label',
                display: ['label'],
              },
            },
          }},model:{value:(_vm.formData.program_year),callback:function ($$v) {_vm.$set(_vm.formData, "program_year", $$v)},expression:"formData.program_year"}})],1),_c('v-col',[_c('geko-input',{attrs:{"item":{
            label: 'Materi Pelatihan 1',
            validation: ['required'],
            col_size: 6,
            type: 'select',
            param: {},
            api: 'GetTrainingMaterials',
            setter: 'first_material',
            // default_label: '',
            option: {
              getterKey: 'data.result',
              list_pointer: {
                label: 'material_name',
                code: 'material_no',
                display: ['material_name'],
              },
            },
          }},model:{value:(_vm.formData.first_material),callback:function ($$v) {_vm.$set(_vm.formData, "first_material", $$v)},expression:"formData.first_material"}})],1)],1),_c('v-row',[_c('v-col',[_c('geko-input',{attrs:{"disabled":!_vm.formData.program_year,"item":{
            label: 'Management Unit',
            validation: ['required'],
            col_size: 6,
            type: 'select',
            setter: 'mu_no',
            param: {
              page: 1,
              per_page: 10,
            },
            api: 'new-utilities/management-units',
            default_label: _vm.formData.mu_no,
            option: {
              getterKey: 'data',
              list_pointer: {
                code: 'mu_no',
                label: 'name',
                display: ['name', 'mu_no'],
              },
            },
          }},model:{value:(_vm.formData.mu_no),callback:function ($$v) {_vm.$set(_vm.formData, "mu_no", $$v)},expression:"formData.mu_no"}})],1),_c('v-col',[_c('geko-input',{attrs:{"item":{
            label: 'Materi Pelatihan 2',
            // validation: ['required'],
            col_size: 6,
            type: 'select',
            param: {},
            api: 'GetTrainingMaterials',
            setter: 'second_material',
            // default_label: '',
            option: {
              getterKey: 'data.result',
              list_pointer: {
                label: 'material_name',
                code: 'material_no',
                display: ['material_name'],
              },
            },
          }},model:{value:(_vm.formData.second_material),callback:function ($$v) {_vm.$set(_vm.formData, "second_material", $$v)},expression:"formData.second_material"}})],1)],1),_c('v-row',[_c('v-col',[_c('geko-input',{attrs:{"disabled":!_vm.formData.program_year || !_vm.formData.mu_no,"item":{
            label: 'Target Area',
            validation: ['required'],
            col_size: 6,
            type: 'select',
            setter: 'target_area',
            param: {
              page: 1,
              per_page: 10,
              program_year: _vm.formData.program_year,
              mu_no: _vm.formData.mu_no
            },
            api: 'new-utilities/target-areas',
            default_label: _vm.formData.target_area,
            option: {
              getterKey: 'data',
              list_pointer: {
                code: 'area_code',
                label: 'name',
                display: ['name', 'area_code'],
                status: 1,
                user_id: null,

              },
            },
          }},model:{value:(_vm.formData.target_area),callback:function ($$v) {_vm.$set(_vm.formData, "target_area", $$v)},expression:"formData.target_area"}})],1),_c('v-col',[_c('geko-input',{attrs:{"disabled":!_vm.formData.first_material || !_vm.formData.second_material,"item":{
              label: 'Materi Pelatihan 3',
              col_size: 6,
              type: 'select',
              param: {},
              api: 'GetTrainingMaterials',
              setter: 'third_material',
              // default_label: '',
              option: {
                getterKey: 'data.result',
                list_pointer: {
                  label: 'material_name',
                  code: 'material_no',
                  display: ['material_name'],
                },
              },
            }},model:{value:(_vm.formData.third_material),callback:function ($$v) {_vm.$set(_vm.formData, "third_material", $$v)},expression:"formData.third_material"}})],1)],1),_c('v-row',[_c('v-col',[_c('geko-input',{attrs:{"disabled":!_vm.formData.program_year || !_vm.formData.mu_no || !_vm.formData.target_area,"item":{
              label: 'Desa',
              validation: ['required'],
              col_size: 6,
              type: 'select',
              api: 'village/dataset',
              param: {
                area_code: _vm.formData.target_area,
                program_year: _vm.formData.program_year
              },
              setter: 'village',
              option: {
                getterKey: 'data',
                list_pointer: {
                  label: 'desas_name',
                  code: 'kode_desa',
                  display: ['desas_name', 'kode_desa'],
                },
              },
            }},on:{"selected":function($event){return _vm.handleOnSelectDesa($event)}},model:{value:(_vm.formData.village),callback:function ($$v) {_vm.$set(_vm.formData, "village", $$v)},expression:"formData.village"}})],1),_c('v-col',[_c('geko-input',{attrs:{"item":{
            label: 'Tanggal Pelatihan',
            validation: ['required'],
            col_size: 6,
            type: 'date',
            setter: 'date',
          }},model:{value:(_vm.formData.training_date),callback:function ($$v) {_vm.$set(_vm.formData, "training_date", $$v)},expression:"formData.training_date"}})],1)],1),_c('v-row',[_c('v-col',[(_vm.allFFByDesa.length > 0)?_c('geko-input',{attrs:{"disabled":!_vm.formData.program_year || !_vm.formData.mu_no || !_vm.formData.target_area
            || !_vm.formData.village || !_vm.farmerByAllFF.size,"item":{
              label: 'Field Facilitator Aktif',
              validation: ['required'],
              col_size: 6,
              type: 'select',
              setter: 'ff_additional',
              option: {
                multiple: true,
                list_pointer: {
                  label: 'field_facilitators_name',
                  code: 'ff_no',
                  display: ['field_facilitators_name', 'ff_no'],
                },
                default_options: _vm.allFFByDesa
              },
            }},on:{"selected":_vm.setFarmerBySelectedFF,"deselected":_vm.unsetFarmerBySelectedFF},model:{value:(_vm.formData.ff_additional),callback:function ($$v) {_vm.$set(_vm.formData, "ff_additional", $$v)},expression:"formData.ff_additional"}}):_vm._e()],1),_c('v-col')],1),_c('v-row',[_c('v-col',[_c('geko-input',{attrs:{"disabled":!_vm.formData.program_year || !_vm.formData.mu_no || !_vm.formData.target_area
            || !_vm.formData.village || !_vm.formData.ff_additional,"item":{
              label: 'Unit Manager',
              validation: ['required'],
              col_size: 6,
              type: 'select',
              api: 'GetEmployeebyPosition',
              param: {
                position_code: _vm.positionCodeUMCA
              },
              setter: 'unit_manager',
              option: {
                getterKey: 'data.result.data',
                list_pointer: {
                  label: 'name',
                  code: 'nik',
                  display: ['name'],
                },
              },
            }},model:{value:(_vm.formData.unit_manager),callback:function ($$v) {_vm.$set(_vm.formData, "unit_manager", $$v)},expression:"formData.unit_manager"}})],1),_c('v-col')],1),_c('v-row',[_c('v-col',[_c('geko-input',{attrs:{"disabled":!_vm.formData.program_year || !_vm.formData.mu_no || !_vm.formData.target_area
            || !_vm.formData.village || !_vm.formData.ff_additional || !_vm.formData.unit_manager,"item":{
              label: 'Field Coordinator',
              validation: ['required'],
              col_size: 6,
              api: 'GetEmployeebyManager',
              param: {
                manager_code: _vm.formData.unit_manager
              },
              type: 'select',
              setter: 'fc_additional',
              option: {
                multiple: true,
                getterKey: 'data.result.data',
                list_pointer: {
                  label: 'name',
                  code: 'nik',
                  display: ['name', 'fc_no'],
                },
              },
            }},model:{value:(_vm.formData.fc_additional),callback:function ($$v) {_vm.$set(_vm.formData, "fc_additional", $$v)},expression:"formData.fc_additional"}})],1),_c('v-col')],1),_c('v-col',{attrs:{"md":"12"}},[_c('div',{staticClass:"d-flex flex-row justify-content-end",staticStyle:{"justify-content":"flex-end"}},[_c('v-btn',{staticClass:"mr-3",attrs:{"variant":"light"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("Batal")]),_c('v-btn',{attrs:{"type":"submit","variant":"success","disabled":_vm.loading}},[_c('v-icon',[_vm._v("mdi-chevron-right")]),_c('span',[_vm._v("Selanjutnya")])],1)],1)])],1)]}}])}),_c('ValidationObserver',{directives:[{name:"show",rawName:"v-show",value:(_vm.form === 2),expression:"form === 2"}],ref:"secondForm",staticClass:"geko-form-wrapper",scopedSlots:_vm._u([{key:"default",fn:function({ handleSubmit }){return [_c('form',{attrs:{"autocomplete":"off"},on:{"submit":function($event){$event.preventDefault();return handleSubmit(_vm.onSubmit)}}},[_c('v-row',[_c('v-col',{staticClass:"form-separator",attrs:{"md":"12"}},[_c('h4',[_vm._v("Tambah Peserta Pelatihan Dari Desa "+_vm._s(_vm.selectedDesaName))])])],1),_c('v-row',[_c('v-col',[_vm._l((_vm.farmerBySelectedFF),function(ff,name,key){return _c('div',[_c('div',{staticClass:"list-search-wrapper",style:({ display: _vm.isActive === name ? 'block' : 'none' })},[_c('v-icon',{staticClass:"prepend"},[_vm._v("mdi-magnify")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(ff.search),expression:"ff.search"}],attrs:{"type":"text","placeholder":'Cari petani'},domProps:{"value":(ff.search)},on:{"input":function($event){if($event.target.composing)return;_vm.$set(ff, "search", $event.target.value)}}}),(typeof ff.search == 'string' && ff.search.length > 0)?_c('v-icon',{staticClass:"append",on:{"click":function($event){ff.search = ''}}},[_vm._v("mdi-close")]):_vm._e()],1)])}),_vm._l((_vm.farmerBySelectedFF),function(ff,name,key){return _c('div',{staticStyle:{"display":"inline-block","margin":"0px 10px 10px 0px"}},[_c('v-btn',{attrs:{"variant":_vm.isActive === name ? 'success' : 'light'},on:{"click":function($event){_vm.isActive = name}}},[_vm._v(_vm._s(ff.field_facilitators_name)+" "),(ff.selectedFarmers.length)?_c('v-badge',{attrs:{"small":"","color":"primary","content":ff.selectedFarmers.length,"inline":""}}):_vm._e()],1)],1)}),_vm._l((_vm.farmerBySelectedFF),function(ff,name,key){return _c('div',{style:({ display: _vm.isActive === name ? 'block' : 'none', margin: '0px 10px 10px 0px' })},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"items":ff.farmers,"headers":_vm.farmerTable.header,"search":ff.search,"show-select":"","disable-sort":"","item-key":"idTblPetani","items-per-page":ff.itemPerPage,"page":ff.page,"footer-props":{
                itemsPerPageText: 'Jumlah Data Per Halaman',
                itemsPerPageOptions: [5, 10, 25, 40, -1],
              }},on:{"update:page":($p) => (_vm.page = $p),"update:items-per-page":($p) => (_vm.itemPerPage = $p)},scopedSlots:_vm._u([{key:"item.no",fn:function({ index }){return [_vm._v(" "+_vm._s(++index)+" ")]}},{key:"item.photo",fn:function({ item }){return [_c('v-avatar',{staticClass:"my-1 cursor-pointer",attrs:{"color":"secondary","size":"30"},on:{"click":() => {
                  // show bigger image | Lightbox
                }}},[_c('img',{attrs:{"src":`${_vm.$store.state.apiUrlImage}Uploads/fphoto_${item.nik}.jpg`,"alt":`Foto petani ${item.nama}`}})])]}},{key:"item.no_petani",fn:function({ item }){return [_c('div',{staticClass:"center-horizontally"},[_vm._v(" "+_vm._s(item.kode)+" ")])]}}],null,true),model:{value:(ff.selectedFarmers),callback:function ($$v) {_vm.$set(ff, "selectedFarmers", $$v)},expression:"ff.selectedFarmers"}})],1)})],2)],1),_c('v-row',[_c('v-col',[_c('geko-input',{attrs:{"item":{
            label: 'Tambah Petani Lain',
            col_size: 6,
            type: 'select',
            api: 'GetFarmerAllAdmin',
            param: {
              typegetdata: 'all',
              mu: _vm.formData.mu_no,
              ta: _vm.formData.target_area
            },
            key: 'selectPetaniLain',
            option: {
              getterKey: 'data.result.data',
              list_pointer: {
                label: 'nama',
                code: 'kode',
                display: ['nama', 'kode'],
              },
              // default_options: allFarmerByMUandTA
            },
          }},on:{"selected":_vm.handleSelectedOtherFarmer}})],1)],1),_c('v-row',[_c('v-col',{staticClass:"form-separator",attrs:{"md":"12"}},[_c('h4',[_vm._v("Peserta Umum")])])],1),_c('v-row',[_c('v-col',[_c('div',{staticClass:"village-person-list"},[_vm._l((_vm.formData.peserta_tambahan),function(person,i){return _c('v-row',{key:'persons-' + i},[_c('v-col',{staticClass:"index-wrapper",attrs:{"md":"1"}},[_c('div',{staticClass:"index"},[_vm._v(_vm._s(i + 1))])]),_c('v-col',{attrs:{"md":"3"}},[_c('geko-input',{attrs:{"item":{
                  label: 'Nama',
                  validation: ['required'],
                  type: 'text',
                }},model:{value:(person.name),callback:function ($$v) {_vm.$set(person, "name", $$v)},expression:"person.name"}})],1),_c('v-col',{attrs:{"md":"2"}},[_c('geko-input',{attrs:{"item":{
                  label: 'Alamat',
                  validation: ['required'],
                  type: 'text',
                }},model:{value:(person.address),callback:function ($$v) {_vm.$set(person, "address", $$v)},expression:"person.address"}})],1),_c('v-col',{attrs:{"md":"2"}},[_c('geko-input',{attrs:{"item":{
                  label: 'No HP/WA',
                  validation: ['required', 'phone'],
                  type: 'text',
                }},model:{value:(person.phone),callback:function ($$v) {_vm.$set(person, "phone", $$v)},expression:"person.phone"}})],1),_c('v-col',{attrs:{"md":"2"}},[_c('geko-input',{attrs:{"item":{
                  label: 'Jenis Kelamin',
                  validation: ['required'],
                  type: 'select',
                  option: {
                    list_pointer: {
                      label: 'label',
                      code: 'label',
                      display: ['label'],
                    },
                    default_options: [
                      { label: 'Laki-laki' },
                      { label: 'Perempuan' },
                    ]
                  }
                }},model:{value:(person.gender),callback:function ($$v) {_vm.$set(person, "gender", $$v)},expression:"person.gender"}})],1),_c('v-col',{staticClass:"d-flex flex-column justify-content-center",staticStyle:{"justify-content":"center","align-items":"flex-start"},attrs:{"md":"1"}},[_c('button',{attrs:{"type":"button"},on:{"click":function($event){return _vm.hapusPesertaUmum(i)}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("mdi-close")])],1)])],1)}),_c('v-row',[_c('v-col',{attrs:{"md":"12"}},[_c('v-btn',{attrs:{"type":"button","variant":"primary"},on:{"click":_vm.tambahPesertaUmun}},[_c('v-icon',[_vm._v("mdi-plus")]),_c('span',[_vm._v("Tambah Peserta Umum")])],1)],1)],1)],2)])],1),_c('v-col',{attrs:{"md":"12"}},[_c('div',{staticClass:"d-flex flex-row justify-content-end",staticStyle:{"justify-content":"flex-end"}},[_c('v-btn',{staticClass:"mr-3",attrs:{"variant":"light"},on:{"click":function($event){_vm.form--}}},[_vm._v("Back")]),_c('v-btn',{attrs:{"type":"button","variant":"success","disabled":_vm.loading},on:{"click":_vm.handleNextButtonPage2}},[_c('v-icon',[_vm._v("mdi-chevron-right")]),_c('span',[_vm._v("Selanjutnya")])],1)],1)])],1)]}}])}),_c('ValidationObserver',{directives:[{name:"show",rawName:"v-show",value:(_vm.form === 3),expression:"form === 3"}],ref:"thirdForm",staticClass:"geko-form-wrapper",scopedSlots:_vm._u([{key:"default",fn:function({ handleSubmit }){return [_c('form',{attrs:{"autocomplete":"off"},on:{"submit":function($event){$event.preventDefault();return handleSubmit(_vm.onSubmit)}}},[_c('v-row',[_c('v-col',{staticClass:"form-separator",attrs:{"md":"12"}},[_c('h4',[_vm._v("Foto Absensi & Dokumentasi")])])],1),_c('v-row',[_c('v-col',[_c('v-btn',{attrs:{"small":"","href":"https://www.iloveimg.com/compress-image","target":"_blank"}},[_c('v-icon',{attrs:{"left":"","small":""}},[_vm._v("mdi-zip-box")]),_vm._v(" klik untuk kompres gambar")],1)],1)],1),_c('v-row',[_c('v-col',{attrs:{"md":"12"}},[_c('geko-input',{attrs:{"item":{
            label: 'Foto Absensi Tertulis',
            validation: ['required'],
            type: 'upload',
            api: '/farmer-training/upload1.php',
            directory: 'absensi-images',
            upload_type: 'image/*',
            setter: 'absent',
            view_data: 'absent',
            require_gps: true,
            isButtonDeleteHidden: true,
            option: {
              max: 5,
              label_hint:
                'Klik gambar untuk memilih berkas yang akan diunggah',
              max_size: 5,
              multiple: true,
            },
          }},model:{value:(_vm.formData.absent),callback:function ($$v) {_vm.$set(_vm.formData, "absent", $$v)},expression:"formData.absent"}})],1)],1),_c('v-row',[_c('v-col',{attrs:{"md":"12"}},[_c('geko-input',{attrs:{"item":{
            label: 'Foto Dokumentasi',
            validation: ['required'],
            type: 'upload',
            api: '/farmer-training/upload1.php',
            directory: 'documentation-photos',
            upload_type: 'image/*',
            setter: 'dokumentasi',
            view_data: 'dokumentasi',
            require_gps: true,
            isButtonDeleteHidden: true,
            option: {
              label_hint:
                'Klik gambar untuk memilih berkas yang akan diunggah',
              max_size: 5,
            },
          }},model:{value:(_vm.formData.dokumentasi),callback:function ($$v) {_vm.$set(_vm.formData, "dokumentasi", $$v)},expression:"formData.dokumentasi"}})],1)],1),_c('v-col',{attrs:{"md":"12"}},[_c('div',{staticClass:"d-flex flex-row justify-content-end",staticStyle:{"justify-content":"flex-end"}},[_c('v-btn',{staticClass:"mr-3",attrs:{"variant":"light"},on:{"click":function($event){_vm.form--}}},[_vm._v("Back")]),_c('v-btn',{attrs:{"type":"submit","variant":"success","disabled":_vm.loading,"outline":""}},[_c('v-icon',[_vm._v("mdi-content-save-all-outline")]),_c('span',[_vm._v("Simpan")])],1)],1)])],1)]}}])}),_c('modal-detail-petani',{attrs:{"isOpen":_vm.isModalDetailOpened,"dataFarmer":_vm.selectedFarmerData},on:{"addedOtherFarmer":_vm.handleAddedOtherFarmer,"batal":function($event){_vm.isModalDetailOpened = false}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }